(function () {
  'use strict';

  // The <script> tag is emitted per gaming-fps block, so it can appear more than
  // once in the DOM. Each duplicated tag executes in its own scope, so the guard
  // must live on a shared global (a module-scoped flag would not dedupe across
  // separate script executions).
  if (window.mGamingFpsCardBound) return;
  window.mGamingFpsCardBound = true;

  const LINK_SELECTOR = '.m-gaming-fps-card__link';
  const SECTION_ID = 'gaming-performance';
  const HEADING_ID = 'gaming-performance-title';
  const FALLBACK_ID = 'product-details';
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  /**
   * Reveal the Performance section whether product details render as tabs
   * (<tabbed-content>) or as an accordion (<details>). The controlling tab is
   * derived from the target's panel via aria-controls, so this is not tied to a
   * fixed tab index and survives block reordering.
   * @param {HTMLElement} target - The #gaming-performance section element.
   */
  function revealSection(target) {
    const panel = target.closest('[role="tabpanel"], [id^="panel-"]');
    const tabBtn = panel ? document.querySelector('[aria-controls="' + panel.id + '"]') : null;

    if (tabBtn) {
      tabBtn.click();
      return;
    }

    const details = target.closest('details');
    if (details) details.open = true;
  }

  /**
   * Scroll the section into view and move focus to its heading so keyboard and
   * screen-reader users follow the in-page jump. Honours prefers-reduced-motion.
   * @param {HTMLElement} scrollTarget - Element to scroll to.
   */
  function focusSection(scrollTarget) {
    const heading = document.getElementById(HEADING_ID) || scrollTarget;
    if (!heading.hasAttribute('tabindex')) heading.setAttribute('tabindex', '-1');
    heading.focus({ preventScroll: true });
    scrollTarget.scrollIntoView({
      behavior: reducedMotion.matches ? 'auto' : 'smooth',
      block: 'start',
    });
  }

  document.addEventListener('click', function (event) {
    const link = event.target.closest(LINK_SELECTOR);
    if (!link) return;

    const target = document.getElementById(SECTION_ID);
    const scrollTarget = target || document.getElementById(FALLBACK_ID);
    if (!scrollTarget) return; // Nothing to reveal; leave the native anchor alone.

    event.preventDefault();
    if (target) revealSection(target);

    // Wait for the tab/accordion to expand before scrolling, so the section is
    // at its final position. Two frames covers the layout + paint after toggling.
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        focusSection(scrollTarget);
      });
    });
  });
})();
